import { motion } from "framer-motion";
import { ShieldCheck, Building2, Clock } from "lucide-react";

export default function PolicyDetailsHeader({ policyType, providerName, coverLabel }) {
  return (
    <div className="overflow-hidden relative p-5 bg-gradient-to-r from-emerald-50 to-green-50 rounded-2xl ring-1 ring-emerald-100">
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="relative z-10"
      >
        <div className="flex flex-wrap gap-3 items-center">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white text-emerald-700 ring-1 ring-emerald-100">
            <ShieldCheck size={16} />
            <span className="text-sm font-semibold">{policyType}</span>
          </span>
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white text-gray-800 ring-1 ring-gray-200">
            <Building2 size={16} />
            <span className="text-sm font-medium">{providerName}</span>
          </span>
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white text-indigo-700 ring-1 ring-indigo-100">
            <Clock size={16} />
            <span className="text-sm font-medium">{coverLabel}</span>
          </span>
        </div>
        <p className="mt-3 text-sm text-gray-700">
          Review your policy details below. Make sure your payment information is correct. We'll issue your digital policy instantly after a successful payment.
        </p>
      </motion.div>
      <div className="absolute -top-16 -right-16 w-48 h-48 bg-emerald-100 rounded-full opacity-60" />
      <div className="absolute -left-12 -bottom-20 w-56 h-56 bg-green-100 rounded-full opacity-60" />
    </div>
  );
}
